import { Controller } from "@hotwired/stimulus"
import { apiJson, formatApiErrorDetail } from "../lib/api_errore"
import { VisiteTrattenute, riparti } from "../lib/visite_trattenute"

// NewsletterForm di components/NewsletterForm.js (31a5bd1): POST /api/newsletter { email, sectors: [settore] } con
// X-CSRF-Token (apiJson); a buon fine il modulo diventa il riquadro «Sei iscritto!» con il toast «Iscrizione
// confermata!», altrimenti il toast col dettaglio dell'errore (422, 429 compresi) o «Iscrizione non riuscita».
// Finché la richiesta è in volo le visite Turbo sono trattenute (lib/visite_trattenute.js): nell'originale la promessa
// sopravviveva alla pagina.
export default class extends Controller {
  static targets = ["modulo", "email", "settore", "invio", "etichetta", "attesa", "fatto"]

  connect() {
    this.visite = new VisiteTrattenute()
    this.occupato = false
  }

  disconnect() {
    this.visite.lascia()
  }

  async invia(event) {
    event.preventDefault()
    if (this.occupato) return
    this.occupato = true
    this.visite.trattieni()
    this.disegna()
    let fatto = false
    try {
      await apiJson("/api/newsletter", { method: "POST", body: { email: this.emailTarget.value, sectors: [this.settoreTarget.value] } })
      fatto = true
      window.toast?.success?.("Iscrizione confermata!")
    } catch (e) {
      window.toast?.error?.(formatApiErrorDetail(e.detail) || "Iscrizione non riuscita")
    } finally {
      this.occupato = false
    }
    if (fatto && this.element.isConnected) this.modulo_fatto()
    else if (this.element.isConnected) this.disegna()
    const url = this.visite.rilascia()
    if (url) riparti(url)
  }

  modulo_fatto() {
    this.moduloTarget.replaceWith(this.fattoTarget.content.cloneNode(true))
  }

  disegna() {
    this.invioTarget.disabled = this.occupato
    this.etichettaTarget.hidden = this.occupato
    this.attesaTarget.classList.toggle("hidden", !this.occupato)
  }
}
